export function u8_random(byteLength) ::
  return crypto.getRandomValues @
    new Uint8Array(byteLength)

export function u8_randomFill(u8) ::
  return crypto.getRandomValues(u8)

export const u8_randomFill_p = async z =>
  u8_randomFill(await z)

export const u8_random_p = async byteLength =>
  u8_random(await byteLength)

